<template>
  <div class="cannot_link_list" :style="{'overflow-y' : overflowY}">
    <!--tabs切换-->
    <div class="baby_manage_tabs_box">
      <ul>
        <li @click="tabsChange('storeGoodList')">店铺货品列表</li>
        <li @click="tabsChange('storeLinkList')">店铺链接列表</li>
        <li class="active">无法识别链接列表</li>
      </ul>
    </div>
    <!--无法识别链接列表模糊查询-->
    <div class="cannot_link_list_top">
      <div>
        <el-select v-model.trim="selectStore" placeholder="请选择">
          <el-option
            v-for="item in storeList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div><input type="text" v-model.trim="ID" title="ID" placeholder="ID"></div>
      <div><input type="text" v-model.trim="linkName" title="名称" placeholder="名称"></div>
      <button class="btn_normal w116" @click="queryData()">查询</button>
      <button class="btn_normal ml10" @click="exportShopErrorLinkExcel()">导出无法识别链接</button>
    </div>
    <!--无法识别链接列表模糊信息-->
    <div class="cannot_link_list_msg">
      <!--表格-->
      <table class="table tb_border">
        <thead>
        <tr>
          <th>图片</th>
          <th>ID</th>
          <th>链接名称</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody v-if="list.length">
        <tr v-for="(item, index) in list" :key="index">
          <td><img :src="item.LinkImgUrl" height="50" width="50"/></td>
          <td>{{item.NumId}}</td>
          <td>{{item.Title}}</td>
          <td>
            <a title="查看未识别详情" @click="ctrlBtn('cannotLinkDetail', item)">查看未识别详情</a>
            <a title="重新下载链接" @click="ctrlBtn('redownloadLink', item)">重新下载链接</a>
          </td>
        </tr>
        </tbody>
        <tbody v-if="!list.length">
        <tr>
          <td colspan="4">暂时没有相关内容</td>
        </tr>
        </tbody>
      </table>

      <!--分页-->
      <div class="text_right mt20" v-if="list.length">
        <el-pagination
          background
          :prev-text="'上一页'"
          :next-text="'下一页'"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 15, 20, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!--弹出框-->
    <cannot-link-list-embed-msg v-if="isShow" :title="dialogTitle" :cannotLinkMsg="linkMsg"
                                :showType="dialogShowType" @cancelbtn="getSelectDialogEmbed"></cannot-link-list-embed-msg>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                @closebtn="closeMsgDialog"></msg-dialog>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="loadingType"></loading-dialog>
  </div>
</template>

<script type="es6">
  import CannotLinkListEmbedMsg from './cannot-link-list-embed-msg';
  import MsgDialog from '../../../public-component/msg-dialog';
  import LoadingDialog from '../../../public-component/loading-dialog';

  export default {
    name: 'cannot-link-list',
    components: {CannotLinkListEmbedMsg, MsgDialog, LoadingDialog},
    watch: {
      'isShow': function (val) {
        if (val) {
          this.overflowY = 'hidden';
        } else {
          this.overflowY = 'auto';
        }
      }
    },
    data() {
      return {
        list: [], // 无法识别的列表
        storeList: [], // 店铺下拉
        selectStore: '', // 店铺选择
        ID: '', // ID
        linkName: '', // 链接名称
        isShow: false, // 提示框显示
        dialogTitle: null, // 弹出框头部名
        dialogShowType: null, // 弹出框类型
        overflowY: 'auto', // 是否出现滚动
        isLoading: '', // 是否显示加载框
        loadingType: 'NOP', // NOP=正常加载  options=操作加载
        time: 3, // 倒计时时间
        timer: null, // 计时器
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '', // 信息框内容
        currentPage: 1, // 当前页数
        pageSize: 10, // 当前显示几条数据
        total: 10 // 总条数
      }
    },
    methods: {
      // 获取店铺下拉框信息
      getAllPXShopList() {
        this.$axios.get(this.Global.getAllPXShopList).then((res) => {
          if (!res.data.errorMsg) {
            if (res.data.resData.length) {
              this.storeList = res.data.resData;
              this.selectStore = res.data.resData[0].id;
              // 无法识别链接分页数据
              this.loadAllLinkErrorPageData();
            } else {
              this.storeList = res.data.resData;
              this.selectStore = '';
            }
          } else {
            this.storeList = [];
            this.selectStore = res.data.errorMsg;
          }
        });
      },

      // 根据查询条件查询
      queryData() {
        this.currentPage = 1;
        this.loadAllLinkErrorPageData();
      },

      // 无法识别链接分页数据
      loadAllLinkErrorPageData() {
        this.loadingType = 'NOP';
        this.isLoading = true;
        const params = {
          ShopId: this.selectStore,
          LinkId: this.ID,
          LinkName: this.linkName,
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        this.$axios.post(this.Global.loadAllLinkErrorPageData, params).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            self.isLoading = false;
            clearTimeout(timer);
            if (res.data) {
              if (!res.data.errorMsg.length) {
                self.list = res.data.resData.DataList;
                self.total = res.data.resData.TotalCounts;
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
                self.list = [];
                self.total = 0;
              }
            }
          }, 500);
        });
      },

      // 无法识别链接导出信息
      exportShopErrorLinkExcel() {
        const params = {
          ShopId: this.selectStore,
          LinkId: this.ID,
          LinkName: this.linkName,
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        this.$axios.post(this.Global.exportShopErrorLinkExcel, params).then((res) => {
          if (!res.data.errorMsg.length) {
            window.open(res.data.resData, '_blank');
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请选择要批量操作的货号';
          }
        });
      },

      // 重新下载链接
      downLink() {
        this.options = 'options';
        this.isLoading = true;
        this.$axios.post(this.Global.downLink(this.selectStore, this.linkMsg.NumId), null).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res.data) {
              if (!res.data.errorMsg.length) {
                self.isMsg = true;
                self.isSuc = true;
                self.txtMsg = '操作成功';
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 500);
        });
      },

      // 查看无法识别链接详情
      getLinkErrorSkuId() {
        this.$axios.post(this.Global.getLinkErrorSkuId(this.linkMsg.Id, this.linkMsg.ShopId), null).then((res) => {
          if (!res.data.errorMsg.length) {
            this.isShow = true;
            this.dialogTitle = '查看未识别编码详情';
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      },

      // 操作按钮
      ctrlBtn(type, linkMsg) {
        this.dialogShowType = type;
        this.linkMsg = linkMsg;
        console.log(this.linkMsg);
        switch (type) {
          case 'cannotLinkDetail':
            this.getLinkErrorSkuId();
            break;
          case 'redownloadLink':
            this.options = 'options';
            this.isLoading = true;
            this.dialogTitle = '重新下载链接';
            this.downLink();
            break;
        }

        // 计时器
        if (this.isLoading) {
          this.time = 3;
          const self = this;
          this.timer = setInterval(function () {
            self.time = --self.time;
            if (self.time < 1) {
              self.isLoading = false;
              clearInterval(self.timer);
            }
          }, 1000);
        }
      },

      // 接收弹出框传送的数据
      getSelectDialogEmbed(e) {
        this.isShow = e.isShow;
      },

      // 分页——当前页面显示条数改变
      handleSizeChange(val) {
        this.pageSize = val;
        this.loadAllLinkErrorPageData();
      },

      // 分页——当前页改变
      handleCurrentChange(val) {
        this.currentPage = val;
        this.loadAllLinkErrorPageData();
      },

      // tabs切换
      tabsChange(value) {
        this.$emit('tabschange', {type: value});
        // this.$emit('tabschange', {type: value, num: 1});
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
      }
    },
    created() {
      // 获取店铺下拉框信息
      this.getAllPXShopList();
    },
    beforeRouteLeave(to, from, next) {
      to.meta.keepAlive = true;
      next();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../assets/css/home-view";

  .cannot_link_list {
    .cannot_link_list_msg {
      height: calc(100% - 130px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/goods-management/baby-management/cannot-link-list.vue